import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
  
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(public loaderService:LoaderService) { }

  ngOnInit() {
  }
}
